import { useEffect, useState } from "react";

import { decoColumns } from "./deco-columns";
import useAxios from "@hooks/use-axios";
import { useParams } from "react-router-dom";
import useSearchParams from "@hooks/use-search-params";

const useChildCompanies = () => {
    const { platformId, clientId } = useParams();
    const { axiosInstance, loading, cancelAllRequests } = useAxios({
        base         : "panel",
        initialLoader: true
    });
    const [data, setData] = useState({ childCompanies: [], pagination: {} });
    const [queryParams, setQueryParams] = useState({});
    const { getSearchParams } = useSearchParams();

    const getChildCompanies = async () => {
        const { data, pagination } = await axiosInstance.get(
            `/client/${platformId}/child-company`,
            {
                params: {
                    parent_id: clientId,
                    page     : getSearchParams("page"),
                    limit    : getSearchParams("limit")
                }
            }
        );

        setData({
            childCompanies: data,
            pagination
        });
    };

    useEffect(() => {
        let isActive = true;
        if (isActive) {
            getChildCompanies();
        }
        return () => {
            isActive = false;
            cancelAllRequests();
        };
    }, [queryParams]);

    return {
        data,
        loading,
        columns: decoColumns(),
        setQueryParams,
        getChildCompanies
    };
};

export default useChildCompanies;
